import { Button, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(2),
}))

export const ModalOptions = styled(Button)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  padding: theme.spacing(2, 0),
  fontWeight: 400,
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: '#002FAF0D',
  },
}))

export const SuccessModalSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 400,
}))

export const ModalButton = styled(Button)(({ theme }) => ({
  border: '1px solid',
  fontWeight: 700,
  fontSize: '16px',
  borderColor: theme.colors.primary.slalomBlue,
  color: theme.colors.primary.slalomBlue,
}))
